/// <reference path="../ObjectDataBuilder.ts" />

namespace SPA
{
	export namespace Realtor
	{

		export class IS24Builder
			extends ObjectDataBuilder<RealtorObjectModel>
		{

			private	m_Parent:	JQuery|ui.base.BaseHTMLElement|null;

			public constructor( data: RealtorObjectModel )
			{
				super( data );

				this.m_Parent	= null;
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement>, navigation?: Navigation ): IS24Builder
			{
				this.empty().remove().appendTo( root.empty() );

				const is24_container_box = new ui.Box.Box( true );
				is24_container_box.rebuild(this);

				is24_container_box.addTitle( 'ImmobilienScout24 - Anzeige' );
				is24_container_box.append(ui.$$.p().text('Diese Option steht nur in der Lizenz-Version zur Verfügung.'));


				// this.buildStatusAnnouncement( this.m_Data, null, is24_container_box );

				return this;
			}

			private buildStatusAnnouncement(
				re: Wollmilch.Realtor.Object,
				announce: {[key: string]: any}|null, // ? Announcement-Objekt
				box: ui.Box.Box
			): void
			{
				const status = new ui.Box.Box( true );

				status.addTitle( 'Status der Anzeige' );

				status.rebuild( box );

				if ( announce === null )
				{
					new ui.base.BaseHTMLElement( 'p' )
						.text( 'Derzeit ist keine Anzeige auf ImmobilienScout24 geschaltet.' )
					.appendTo( status );

					this.buildEmptyAnnouncement( re, box );
				}
				else
				{
					// ! Baue den anderen kram
				}
			}

			private buildEmptyAnnouncement( re: Wollmilch.Realtor.Object, box: ui.Box.Box ): void
			{
				const form = new ui.Form.Form(
					{
						action: 'RealEstate/export/' + btoa( this.m_Data.ObjectNumber ),
						method: 'POST',
						notSwitchable: true,
						submit: ( _m: Wollmilch.AJAXMethod, _u: string, params: ui.Form.IFormParameter ) =>
						{
							console.log( params );

							// # Hier AJAX mit Erstellung der Anzeige

							new Wollmilch.AJAX(
								{
									url: _u,
									method: _m,
									data: params,
									on:
									{
										success: ( text: string ): void =>
										{
											const result = Wollmilch.jsonize( text );

											if ( !result || !result.success )
											{
												app.addNotify(
													{
														title: [ 'Fehler' ],
														body: [
															'Der Export ist fehlgeschlagen, bitte erneut versuchen'
														],
														context: "danger",
														timeout: Number(app.getConfigValue("ToastTimeout"))
													}
												);

												return;
											}

											app.addNotify(
												{
													title: [ 'Export efolgreich' ],
													body: [
														'Anzeige erfolgreich exportiert',
														ui.$$.a().attr( 'target', 'immo24' )
														.attr(
															'href',
															'https://www.sandbox-immobilienscout24.de/scoutmanager/exposemanager/' +
															result.data.RealEstate.external_id
														)
														.text( 'Klicke hier' )
													],
													context: 'success',
													timeout: 100000
												}
											);
										},
										beforeSend: ( options: Wollmilch.IAJAXOptions ): void =>
										{
											// @ts-ignore
											if ( options.data && options.data.courtage.courtage === 0.0 )
											{
											// @ts-ignore
												options.data.courtage.hasCourtage = 'NO';
											}
											else
											{
											// @ts-ignore
												options.data.courtage.hasCourtage = 'YES';
											}
										}
									}
								},
								Wollmilch.AJAXCallbase_e.IS24_V1
							).send();
						},
						classes: [ 'box', 'form-horizontal' ]
					}
				);

				new ui.base.BaseHTMLElement( 'p' )
					.addClass( 'box-title small-caps' )
					.text( 'Daten der Anzeige' )
				.appendTo( form );

				/*
					# Formular hier befüllen!!!!!!
				*/


				form.Input( new ui.Form.TextInput( 'house', { name: 'type' } ) );
				this.buildEmptyAnnouncementFormHouse( re, form );

				new ui.base.Button(
					'Anzeige schalten',
					{
						context: 'success',
						size: 'xs',
						attr:
						{
							type: 'submit'
						}
					}
				).rebuild( form );

				// new ui.base.Button(
				// 	'Zurücksetzen',
				// 	{
				// 		context: 'primary',
				// 		size: 'xs',
				// 		attr:
				// 		{
				// 			type: 'reset'
				// 		}
				// 	}
				// ).rebuild( form );

				form.Initialize();

				form.appendTo( box );
			}

			private buildEmptyAnnouncementFormHouse( re: Wollmilch.Realtor.Object, form: ui.Form.Form ): void
			{
				this.AddInput(
					new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group clearfix' ).appendTo( form ),
					form,
					[
						{
							label: 'Titel der Anzeige*:',
							size:
							{
								xs: 12,
								sm: 12,
								md: 10,
								lg: 10
							},
							input: new ui.Form.TextInput(
								null,
								{
									control: true,
									noautocomplete: true,
									placeholder: 'Titel der Anzeige',
									name: 'title',
									required: true
								}
							)
						}
					]
				);

				this.AddInput(
					new ui.base.BaseHTMLElement('div').addClass( 'form-group clearfix' ).appendTo( form ),
					form,
					[
						{
							size:
							{
								xs: 6,
								sm: 6,
								md: 6,
								lg: 6
							},
							input: new ui.Form.Checkbox(
								{
									value: 'true',
									title: 'Adresse in Anzeige anzeigen',
									descriptor:
									{
										name: 'showAddress'
									}
								}
							)
						}
					]
				);

//#region address
				const fg_address = new ui.base.BaseHTMLElement( 'div' )
					.addClass( 'form-group clearfix' )
				.appendTo( form );
				const streetInput = new ui.Form.TextInput(
					re.Address.Street,
					{
						name: 'address.street',
						classes: ['form-control'],
						readonly: true,
						required: true
					}
				);
				form.Input( streetInput );
				streetInput.Base().addClass( 'col-xs-11' );
				streetInput.rebuild(
					new ui.base.BaseHTMLElement( 'div' )
					.addClass( 'col-xs-8' )
					.append(
						new ui.base.BaseHTMLElement( 'label' )
						.addClass( 'control-label col-xs-1' )
						.text( 'Straße*:' )
					)
					.appendTo( fg_address )
				);
				const hnInput = new ui.Form.TextInput(
					re.Address.HouseNumber,
					{
						name: 'address.houseNumber',
						classes: ['form-control'],
						readonly: true,
						required: true
					}
				);
				hnInput.Base().addClass( 'col-xs-6' );
				form.Input( hnInput );
				hnInput.rebuild(
					new ui.base.BaseHTMLElement( 'div' )
					.addClass( 'col-xs-4' )
					.append(
						new ui.base.BaseHTMLElement( 'label' )
						.addClass( 'form-label col-xs-6' )
						.text( 'Hausnummer*:' )
					)
					.appendTo( fg_address )
				);
				const zipInput = new ui.Form.TextInput(
					re.Address.PostalCode,
					{
						name: 'address.postalCode',
						classes: ['form-control'],
						readonly: true,
						required: true
					}
				);
				zipInput.Base().addClass( 'col-xs-9' );
				form.Input( zipInput );
				zipInput.rebuild(
					new ui.base.BaseHTMLElement( 'div' )
					.addClass( 'col-xs-4' )
					.append(
						new ui.base.BaseHTMLElement( 'label' )
						.addClass( 'control-label col-xs-3' )
						.text( 'Postleitzahl*:' )
					)
					.appendTo( fg_address )
				);
				const cityInput = new ui.Form.TextInput(
					re.Address.City,
					{
						name: 'address.city',
						classes: ['form-control'],
						readonly: true,
						required: true
					}
				);
				cityInput.Base().addClass( 'col-xs-9' );
				form.Input( cityInput );
				cityInput.rebuild(
					new ui.base.BaseHTMLElement( 'div' )
					.addClass( 'col-xs-8' )
					.append(
						new ui.base.BaseHTMLElement( 'label' )
						.addClass( 'form-label col-xs-3' )
						.text( 'Stadt*:' )
					)
					.appendTo( fg_address )
				);
//#endregion

				// TODO temp stuff, contact selection needed!!!!
				{
					form.append(
						new ui.base.BaseHTMLElement( 'p' )
						.addClass( 'form-require small-caps text-danger' )
						.text( 'Hier sollte eine Auswahl der Kontakte hin!!!!' )
					);

					const contact = new ui.Form.NumberInput( 1, { name: 'contact_id' } );

					contact.Initialize();

					form.Input( contact );
				}

				let bt = 'OTHER';

				if ( this.m_Data.Premise && this.m_Data.Premise.Building )
				{
					switch ( this.m_Data.Premise.Building[ 0 ].Data.General.BuildingKind )
					{
						case 'FamilyHouse':			bt = 'SINGLE_FAMILY_HOUSE';	break;
						case 'SemiHouse':				bt = 'SEMIDETACHED_HOUSE';	break;
						case 'EndHouse':				bt = 'END_TERRACE_HOUSE';		break;
						case 'MiddleHouse':			bt = 'MID_TERRACE_HOUSE';		break;
						case 'ApartmentHouse':	bt = 'MULTI_FAMILY_HOUSE';	break;
					}
				}

				this.AddInput(
					form,
					form,
					[
						{
							label: 'Gebäudetyp*:',
							size:
							{
								xs: 10,
								sm: 10,
								md: 10,
								lg: 10
							},
							input: new ui.Form.Select(
								{
									option:
									{
										SINGLE_FAMILY_HOUSE: 'Einfamilienhaus (freistehend)',
										MID_TERRACE_HOUSE: 'Reihenmittelhaus',
										END_TERRACE_HOUSE: 'Reiheneckhaus',
										MULTI_FAMILY_HOUSE: 'Mehrfamilienhaus',
										BUNGALOW: 'Bungalow',
										FARM_HOUSE: 'Bauernhaus',
										SEMIDETACHED_HOUSE: 'Doppelhaushälfte',
										VILLA: 'Villa',
										CASTLE_MANOR_HOUSE: 'Burg/Schloss',
										SPECIAL_REAL_ESTATE: 'Besondere Immobilie',
										TERRACE_HOUSE: 'Reihenhaus',
										OTHER: 'Wohnimmobilie (sonstiges)'
									},
									name: 'buildingType',
									required: true
								},
								bt
							)
						}
					]
				);

				{
					const fg_price = new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group clearfix' ).appendTo( form );
					this.AddInput(
						new ui.base.BaseHTMLElement( 'div' ).addClass( 'col-xs-8' ).appendTo( fg_price ),
						form,
						[
							{
								label: 'Preis*:',
								size:
								{
									xs: 12,
									sm: 12,
									md: 10,
									lg: 10
								},
								input: new ui.Form.NumberInput(
									0,
									{
										name: 'price.value',
										min: 0.0,
										step: 500.0
									}
								)
							}
						]
					);

					this.AddInput(
						new ui.base.BaseHTMLElement( 'div' ).addClass( 'col-xs-4' ).appendTo( fg_price ),
						form,
						[
							{
								label: 'Währung*:',
								size:
								{
									xs: 12,
									sm: 12,
									md: 9,
									lg: 9
								},
								input: new ui.Form.Select(
									{
										name: 'price.currency',
										option:
										{
											EUR: '€ - Euro'
										},
										disabled: true
									},
									'EUR'
								)
							}
						]
					);
				}

				this.AddInput(
					new ui.base.BaseHTMLElement( 'div' ).addClass( 'col-xs-8' )
					.appendTo( new ui.base.BaseHTMLElement('div').addClass( 'form-group clearfix' ).appendTo( form ) ),
					form,
					[
						{
							label: 'Courtage*:',
							size:
							{
								xs: 12,
								sm: 12,
								md: 10,
								lg: 10
							},
							input: new ui.Form.NumberInput(
								0.0,
								{
									name: 'courtage.courtage',
									min: 0.0,
									max: 100.0,
									step: 0.01
								},
								false
							)
						}
					]
				);

				this.AddInput(
					new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group clearfix' ).appendTo( form ),
					form,
					[
						{
							label: 'Anzahl der Räume*:',
							size:
							{
								xs: 12,
								sm: 12,
								md: 9,
								lg: 9
							},
							input: new ui.Form.NumberInput(
								1,
								{
									min: 1,
									step: 1,
									name: 'numberOfRooms',
									required: true
								}
							)
						}
					]
				);

				{
					const plotarea = (this.m_Data.Premise ? this.m_Data.Premise.Data.General.PlotArea.Premise : 1) || 1;

					this.AddInput(
						new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group clearfix' ).appendTo( form ),
						form,
						[
							{
								label: 'Grundstücksfläche*:',
								size:
								{
									xs: 12,
									sm: 12,
									md: 9,
									lg: 9
								},
								input: new ui.Form.NumberInput(
									parseFloat( plotarea as string ),
									{
										min: 1,
										step: 1,
										name: 'plotArea',
										required: true
									}
								)
							}
						]
					);
				}

				{
					const livingarea =
						(
							this.m_Data.Premise && this.m_Data.Premise.Building ?
								this.m_Data.Premise.Building[ 0 ].Data.Applicability.Area :
								1
						) || '1'
					;

					this.AddInput(
						new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group clearfix' ).appendTo( form ),
						form,
						[
							{
								label: 'Wohnfläche*:',
								size:
								{
									xs: 12,
									sm: 12,
									md: 9,
									lg: 9
								},
								input: new ui.Form.NumberInput(
									parseFloat( livingarea.toString() ),
									{
										min: 1,
										step: 1,
										name: 'livingSpace',
										required: true
									},
									true
								)
							}
						]
					);
				}

				{
					const cy =
						this.m_Data.Premise && this.m_Data.Premise.Building ?
							this.m_Data.Premise.Building[ 0 ].Data.General.BuildYear :
							null
					;

					this.AddInput(
						new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group clearfix' ).appendTo( form ),
						form,
						[
							{
								label: 'Baujahr*:',
								size:
								{
									xs: 12,
									sm: 12,
									md: 9,
									lg: 9
								},
								input: new ui.Form.NumberInput(
									cy,
									{
										min: 1,
										step: 1,
										name: 'constructionYear',
										required: true
									},
									true
								)
							}
						]
					);
				}

				this.AddInput(
					new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group clearfix' ).appendTo( form ),
					form,
					[
						{
							label: 'Qualität der Ausstattung*:',
							size:
							{
								xs: 12,
								sm: 12,
								md: 9,
								lg: 9
							},
							input: new ui.Form.Select(
								{
									name: 'interiorQuality',
									required: true,
									option:
									{
										SIMPLE: 'Einfach',
										NORMAL: 'Normal',
										SOPHISTICATED: 'Gehoben',
										LUXURY: 'Luxus',
										NO_INFORMATION: 'Keine Information'
									}
								},
								'NO_INFORMATION'
							)
						}
					]
				);

				this.AddInput(
					new ui.base.BaseHTMLElement( 'div' ).addClass( 'form-group clearfix' ).appendTo( form ),
					form,
					[
						{
							label: 'Bauphase*:',
							size:
							{
								xs: 12,
								sm: 12,
								md: 9,
								lg: 9
							},
							input: new ui.Form.Select(
								{
									name: 'constructionPhase',
									required: true,
									option:
									{
										COMPLETED: 'Fertiggestellt',
										UNDER_CONSTRUCTION: 'Im Bau',
										PROJECTED: 'In Planung',
										NO_INFORMATION: 'Keine Information'
									}
								},
								this.m_Data.Premise && this.m_Data.Premise.Building ?
									(
										this.m_Data.Premise.Building[ 0 ].Data.General.ConstructionRate === 'underConstruction' ?
										'UNDER_CONSTRUCTION' : 'COMPLETED'
									) :
									'NO_INFORMATION'
							)
						}
					]
				);
			}
		}
	}
}
